<template>
  <div class="ExportImportDG2">
    <v-menu :close-on-content-click="false" min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="neumorphism-out-animated"
          v-bind="attrs"
          v-on="on"
          :aria-label="$t('dg2Btn')"
        >
          <v-icon color="red lighten-1"> mdi-swap-vertical </v-icon>
        </v-btn>
        <span class="text">{{ $t("gestion-interventions") }}</span>
      </template>

      <v-card v-click-outside="closeDialog">
        <v-card-text>
          <v-row>
            <!-- date picker 1 -->
            <v-col cols="12" sm="6" md="6">
              <v-menu
                v-model="datePickerStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text>
                    <v-text-field
                      id="datepicker-start-add-event"
                      v-model="value.dateStart"
                      :label="$t('addEventCard.dateStart')"
                      prepend-icon="mdi-calendar"
                      :rules="emptyField"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </v-card-text>
                </template>

                <v-date-picker
                  v-model="value.dateStart"
                  :max="value.dateEnd"
                  :locale="this.$i18n.locale"
                  @input="datePickerStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- date picker 2 -->
            <v-col cols="12" sm="6" md="6">
              <v-menu
                v-model="datePickerEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card-text>
                    <v-text-field
                      id="datepicker-end-add-event"
                      v-model="value.dateEnd"
                      :label="$t('addEventCard.dateEnd')"
                      prepend-icon="mdi-calendar"
                      :rules="emptyField"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </v-card-text>
                </template>

                <v-date-picker
                  v-model="value.dateEnd"
                  :locale="this.$i18n.locale"
                  :min="value.dateStart"
                  @input="datePickerEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="value.dateStart == null || value.dateEnd == null"
            text
            color="red lighten-1"
            @click="openLoginWdg2"
          >
            <span>{{ $t("memento.import") }}</span>
          </v-btn>
        </v-card-actions>
        <v-card-text class="errors" v-if="showErrorMessage">
          {{ errorMessage }}
        </v-card-text>
      </v-card>
    </v-menu>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="red darken-1"
      class="loader"
    ></v-progress-circular>
    <div class="login-wdg2">
      <login-wdg-2
        v-if="showLoginWdg2Card"
        @logInUser="logInUserWdg2"
        @wdg2Close="wdg2Close"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoginWdg2 from "@/components/components-base/LoginWdg2.vue";

export default {
  name: "export-import-dg2",
  components: { LoginWdg2 },
  data() {
    return {
      datePickerStart: false,
      datePickerEnd: false,
      showErrorMessage: false,
      errorMessage: "",
      menu: false,
      showLoginWdg2Card: false,
      loading: false,
      value: {
        dateStart: null,
        dateEnd: null,
      },
      emptyField: [(v) => !!v || this.$t("errorFrontEnd.requiredField")],
    };
  },
  methods: {
    ...mapActions("eventModule", ["loadEvents", "fetchEventsDG2"]),
    closeDialog() {
      this.showErrorMessage = false;
      this.errorMessage = "";
    },
    openLoginWdg2() {
      this.showLoginWdg2Card = true;
      this.closeDialog();
    },
    async logInUserWdg2(value) {
      this.showLoginWdg2Card = false;
      this.loading = true;
      await this.fetchEventsDG2({ logInUser: value, year: this.value });
      await this.loadEvents();
      this.loading = false;
    },
    async wdg2Close(value) {
      this.showLoginWdg2Card = value;
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.ExportImportDG2 {
  margin: 10px 0 0 0;
  border-radius: 50px;

  button {
    margin: 0 10px 0 0;
  }
}

.login-wdg2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.loader {
  position: absolute;
  margin-left: 1rem;
}

.errors {
  width: 290px;
  word-wrap: break-word;
  margin: 0;
  color: red !important;
}
</style>
